import { types, flow, applySnapshot, cast } from 'mobx-state-tree';
import qs from 'qs';

import { ApiStore } from '@src/features/common';
import * as API from '@src/services/companies';
import { deleteFalsyKeys } from '@src/helpers/deleteFalsyKeys';
import { JOB_STATES_MAP } from 'src/constants';
import { toast } from 'src/components';
import { Filters } from './Filters';
import { AddCandidate } from './AddCandidate';

export const CompanyDashboardStore = types
  .compose(
    ApiStore,
    types.model({
      modal: AddCandidate,
      filters: Filters,
      data: types.array(types.frozen())
    })
  )
  .actions(self => {
    return {
      fetchFilters: flow(function* fetch() {
        const res = yield self.fetch(API.getFilters());
        self.filters = res;
      }),
      fetchJob: flow(function* fetch(id) {
        const data = yield self.fetch(API.getDashboardJob(id));
        const updatedJob = data.jobs[0];

        self.data = cast(self.data.map(job => (job.id === id ? { ...job, ...updatedJob } : job)));
      }),
      fetchJobs: flow(function* fetch() {
        if (self.state === 'pending') {
          self.abort();
        }
        const filtersString = qs.stringify(deleteFalsyKeys(self.filters.activeFilters), {
          addQueryPrefix: true,
          arrayFormat: 'brackets'
        });

        const res = yield self.fetch(API.getDashboardJobs(filtersString));

        applySnapshot(self.data, res?.jobs || {});
      })
    };
  })
  .actions(self => ({
    fetchData: flow(function* fetch() {
      yield self.fetchFilters();
      yield self.fetchJobs();
    }),
    deleteJob: flow(function* fetch(id) {
      yield self.delete(`companies/companyId/jobs/${id}`);
      self.fetchJobs();
    }),
    changeJobState: flow(function* fetch(newState: 'close' | 'publish' | 'unpublish', id) {
      const mapState = {
        close: JOB_STATES_MAP.closed,
        publish: JOB_STATES_MAP.published,
        unpublish: JOB_STATES_MAP.unpublished
      };
      yield self.patch<{ new_state: string }>(API.setJobState(id), { new_state: mapState[newState] });
      // refetch updated job
      self.fetchJob(id);

      toast.info('Job status was successfully changed');
    }),
    setFilter: function (newFilters) {
      if (newFilters?.experiences) {
        //  wrap expirience filter in array because we can!
        self.filters.activeFilters = {
          ...self.filters.activeFilters,
          ...{ ...newFilters, experiences: [newFilters.experiences] }
        };
      } else {
        self.filters.activeFilters = { ...self.filters.activeFilters, ...newFilters };
      }

      self.fetchJobs();
    }
  }));
